import Speaker from './track'

export default Speaker
